module.exports = __webpack_public_path__ + "media/images/calendar/july-d585fc9c668615cd7a132e2abccefc90.jpg";